import service from '@/service'
import urlManager from '@/urlManager'
import * as R from 'ramda'

/**
 * This is the store module for Org/Team Vision
 */
export default {
  namespaced: true,
  state: () => ({
    vision: {}
  }),
  mutations: {
    SET_TEAM_VISION(state, { teamId, vision }) {
      state.vision = R.assocPath(['teams', teamId], vision, state.vision)
    }
  },
  actions: {
    async getTeamVision({ commit }, { orgId, teamId }) {
      const response = await service.client.get(urlManager.teamVision({ orgId, teamId }))
      commit('SET_TEAM_VISION', { teamId, vision: response.data })
      return response.data
    },
    async updateTeamVision({ commit }, { orgId, teamId, vision }) {
      const response = await service.client.put(urlManager.teamVision({ orgId, teamId }), vision)
      commit('SET_TEAM_VISION', { teamId, vision })
      return response.data
    }
  }
}
